export const GET_ORDERS: string = 'src/pages/orders/GET_ORDERS';
export const GET_ORDERS_SUCCESS: string = 'src/pages/orders/GET_ORDERS_SUCCESS';
export const GET_ORDERS_FAILED: string = 'src/pages/orders/GET_ORDERS_FAILED';

export const GET_ORDER_WITH_ID: string = 'src/pages/orders/GET_ORDER_WITH_ID';
export const GET_ORDER_WITH_ID_SUCCESS: string =
  'src/pages/orders/GET_ORDER_WITH_ID_SUCCESS';
export const GET_ORDER_WITH_ID_FAILED: string =
  'src/pages/orders/GET_ORDER_WITH_ID_FAILED';

export const UPDATE_ORDER_STATUS: string =
  'src/pages/orders/UPDATE_ORDER_STATUS';
export const UPDATE_ORDER_STATUS_SUCCESS: string =
  'src/pages/orders/UPDATE_ORDER_STATUS_SUCCESS';
export const UPDATE_ORDER_STATUS_FAILED: string =
  'src/pages/orders/UPDATE_ORDER_STATUS_FAILED';

export const ACTION_RETRIEVE_RUBIKA_ORDERS: string =
  'src/pages/orders/ACTION_RETRIEVE_RUBIKA_ORDERS';
export const ACTION_RETRIEVE_RUBIKA_ORDERS_SUCCESS: string =
  'src/pages/orders/ACTION_RETRIEVE_RUBIKA_ORDERS_SUCCESS';
export const ACTION_RETRIEVE_RUBIKA_ORDERS_FAILED: string =
  'src/pages/orders/ACTION_RETRIEVE_RUBIKA_ORDERS_FAILED';

export const SCHEDULE_ORDERS: string = 'src/pages/bundles/SCHEDULE_ORDERS';
export const SCHEDULE_ORDERS_SUCCESS: string =
  'src/pages/bundles/SCHEDULE_ORDERS_SUCCESS';
export const SCHEDULE_ORDERS_FAILED: string =
  'src/pages/bundles/SCHEDULE_ORDERS_FAILED';

export const CANCEL_ORDER: string = 'src/pages/orders/CANCEL_ORDER';
export const CANCEL_ORDER_SUCCESS: string =
  'src/pages/orders/CANCEL_ORDER_SUCCESS';
export const CANCEL_ORDER_FAILED: string =
  'src/pages/orders/CANCEL_ORDER_FAILED';

export const GET_LOGS: string = 'src/pages/orders/GET_LOGS';
export const GET_LOGS_SUCCESS: string = 'src/pages/orders/GET_LOGS_SUCCESS';
export const GET_LOGS_FAILED: string = 'src/pages/orders/GET_LOGS_FAILED';

export const GET_ALL_ORDERS: string = 'src/pages/orders/GET_ALL_ORDERS';
export const GET_ALL_ORDERS_SUCCESS: string = 'src/pages/orders/GET_ALL_ORDERS_SUCCESS';
export const GET_ALL_ORDERS_FAILED: string = 'src/pages/orders/GET_ALL_ORDERS_FAILED';

export const UPDATE_ALL_ORDER_STATUS: string =
  'src/pages/orders/UPDATE_ALL_ORDER_STATUS';
export const UPDATE_ALL_ORDER_STATUS_SUCCESS: string =
  'src/pages/orders/UPDATE_ALL_ORDER_STATUS_SUCCESS';
export const UPDATE_ALL_ORDER_STATUS_FAILED: string =
  'src/pages/orders/UPDATE_ALL_ORDER_STATUS_FAILED';
